var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "e782cd1926af5b30d82671ae2ab2f7a9e4e655f3"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["butternutbox-frontend@butternut"] = {
  id: "e782cd1926af5b30d82671ae2ab2f7a9e4e655f3"
};